import React from "react";
import HRDashboard from "../components/HRDashboard/HRDashboard";

const HRDashboardPage = () => {
  return (
   
      <HRDashboard />
    
  );
};

export default HRDashboardPage;
